import {CBORReader, decode} from '@wonderlandengine/api';

export class DataManager {
    private static _instance: DataManager;

    static get instance(): DataManager {
        if (!DataManager._instance) {
            DataManager._instance = new DataManager();
        }
        return DataManager._instance;
    }

    private constructor() {}

    async loadData<T>(url: string): Promise<T> {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            if (url.endsWith('.json')) {
                const data: T = await response.json();
                return data;
            } else {
                const arrayBuffer = await response.arrayBuffer();
                const rawData = new Uint8Array(arrayBuffer);
                const data = decode<T>(rawData);
                return data;
            }
        } catch (error) {
            console.error(`Error loading data (${url}):`, error);
            throw error;
        }
    }
}
